<template>
  <v-card class="mt-3 ma-2">
    <v-toolbar :color="color" dark>
      <v-toolbar-title>{{ header }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!readonly" @click="$refs.fileInput.click()" icon>
        <v-icon color="white">add</v-icon>
      </v-btn>

      <input
        @change="uploadFile"
        ref="fileInput"
        id="fileInput"
        type="file"
        v-show="false"
        :accept="acceptedFiles"
        aria-label="label for switch"
      />
    </v-toolbar>

    <v-list two-line>
      <template v-for="(item, index) in documents">
        <v-list-tile :key="item.id" avatar>
          <v-list-tile-avatar>
            <v-icon color="primary">assignment</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title v-html="item.fileName"></v-list-tile-title>
            <template v-if="!readonly">
              <v-list-tile-sub-title
                v-html="displayDateTime(item.creationDate)"
              ></v-list-tile-sub-title>
              <v-list-tile-action-text
                v-html="getAgencyContestFileUrl(item.id)"
              ></v-list-tile-action-text>
            </template>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn @click="downloadFile(item)" icon ripple>
              <v-icon color="primary">cloud_download</v-icon>
            </v-btn>
          </v-list-tile-action>

          <v-list-tile-action>
            <v-btn
              v-if="!readonly"
              @click="deleteFile(item, index)"
              icon
              ripple
            >
              <v-icon color="lightred">delete</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { Dates } from "@/utils/Dates";
import { Files } from "@/utils/Files";
import { Api } from "@/api";
import { AgencyContestDocument } from "@/api/generated/AgencyContestDocument";

export default {
  name: "AgencyDocumentsList",

  data() {
    return {};
  },

  props: {
    color: String,
    header: String,
    contestId: String,
    documentType: String,
    documents: Array,
    readonly: {
      default: false
    }
  },

  methods: {
    downloadFile(file) {
      this.downloadAgencyContestFile(this, file.id, file.fileName);
    },

    deleteFile(file, index) {
      AgencyContestDocument.delete(this, file.id,
        successResponse => {
          this.$delete(this.documents, index);
          this.$messagesBus.$emit("success", "Dokument został usunięty", successResponse);
        },
        errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się poprawnie usunąć dokumentu", errorResponse);
        });
    },

    async uploadFile() {
      if (this.hasIncorrectFilesExtension(this.$refs.fileInput.files)) {
        Files.methods.clearFileInput('fileInput');
        this.$messagesBus.$emit("error", "Wgrywanie plików w tym formacie jest niedozwolone. " +
          "Dozwolone formaty plików to " + this.acceptedFiles.split(",").join(", "));
        return;
      }
      let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.fileInput.files);
      if (!validFilesSize) {
        Files.methods.clearFileInput('fileInput');
        return;
      }
      Api.postMultipart(this, "/agency-contest-document", this.$refs.fileInput.files[0],
        {
          "contestId": this.contestId,
          "documentType": this.documentType,
        },
        successResponse => {
          this.documents.push(successResponse);
          Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("success", "Dokument został dodany", successResponse);
        },
        errorResponse => {
          Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Nie udało się poprawnie dodać dokumentu", errorResponse);
        });
    },
  },

  mixins: [
    Dates,
    Files,
  ],
};
</script>

<style scoped>
.theme--dark .v-list__tile__action-text {
  color: #fff;
}

.theme--dark .red--text.text--lighten-1 {
  color: yellow !important;
}
</style>
